(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wowrio-native-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wr-native-drawer-host')) {
    customElements.define('wr-native-drawer-host', class extends HTMLElement {
      connectedCallback() {
        if (this.drawer || this.scheduled) return;
        this.scheduled = true;
        queueMicrotask(() => {
          this.scheduled = false;
          if (!this.isConnected || this.drawer) return;
          const template = this.querySelector(':scope > template');
          const source = template?.content.firstElementChild;
          if (!source) return;
          this.drawer = source.cloneNode(true);
          this.append(this.drawer);
        });
      }

      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.drawer?.remove();
          this.drawer = null;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wowrio-native-purchase-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wr-native-purchase-coordinator')) {
    class WrNativePurchaseCoordinator extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.scope = document.getElementById(`shopify-section-${this.dataset.wrSection}`) || this.closest('.shopify-section');
        this.form = document.getElementById(this.dataset.wrForm);
        if (!this.scope || !this.form) return;
        this.variants = JSON.parse(this.querySelector('[data-wr-variants]').textContent);
        this.copy = JSON.parse(this.querySelector('[data-wr-copy]').textContent);
        this.eligibleIds = new Set(['9932104106283','9933687947563','10470775226667','10365997515051','10279020069163','10495607505195','10496555942187']);
        this.deviceIds = new Set(['9932104106283','9933687947563','10470775226667']);
        this.careIds = new Set(['10279020069163','10495607505195','10496555942187']);
        this.currency = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.wrCurrency || 'USD'});
        const options = {signal:this.abort.signal};
        this.form.addEventListener('formdata', event => this.extendFormData(event.formData), options);
        this.scope.addEventListener('change', event => this.changed(event), options);
        this.scope.addEventListener('input', event => { if (event.target.name === 'quantity') this.update(); }, options);
        this.form.addEventListener('variant:change', () => requestAnimationFrame(() => this.update()), options);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); }
      extras() { return [...this.scope.querySelectorAll('[data-wr-extra]')].filter(extra => extra.dataset.wrForm === this.dataset.wrForm); }
      summaries() { return [...this.scope.querySelectorAll('[data-wr-summary]')].filter(summary => summary.dataset.wrForm === this.dataset.wrForm); }
      selected(extra) { const toggle = extra.querySelector('[data-wr-extra-toggle]'); return Boolean(toggle?.checked && !toggle.disabled); }
      money(cents) { return this.currency.format(Number(cents || 0) / 100); }
      quantity(value) { return Math.max(1,Math.floor(Number(value) || 1)); }
      extraQuantity(extra, mainQuantity) {
        return extra.dataset.wrKind === 'care' && this.careIds.has(extra.dataset.wrProduct) && this.deviceIds.has(this.dataset.wrProduct) ? mainQuantity : this.quantity(extra.dataset.wrQuantity);
      }
      selection(mainId = this.form.elements.namedItem('id')?.value, mainQuantity = this.form.elements.namedItem('quantity')?.value) {
        const variant = this.variants.find(item => String(item.id) === String(mainId)) || this.variants[0];
        if (!variant) return null;
        const quantity = this.quantity(mainQuantity);
        const main = {id:String(variant.id),productId:this.dataset.wrProduct,quantity,amount:Number(variant.price)*quantity,variant};
        const seen = new Set([main.id]);
        const extras = [];
        for (const extra of this.extras()) {
          if (!this.selected(extra) || seen.has(extra.dataset.wrVariant)) continue;
          seen.add(extra.dataset.wrVariant);
          const extraQuantity = this.extraQuantity(extra,quantity);
          extras.push({id:extra.dataset.wrVariant,productId:extra.dataset.wrProduct,quantity:extraQuantity,amount:Number(extra.dataset.wrPrice)*extraQuantity,extra});
        }
        const lines = [main,...extras];
        const count = lines.reduce((sum,line) => sum+(this.eligibleIds.has(line.productId) ? line.quantity : 0),0);
        const campaign = (this.dataset.wrCampaign || '').trim();
        const active = campaign === 'prime' || campaign === 'halloween';
        const rate = active ? count >= 3 ? 25 : count >= 2 ? 15 : 0 : 0;
        for (const line of lines) { line.discount = this.eligibleIds.has(line.productId) ? Math.round(line.amount*rate/100) : 0; line.final = line.amount-line.discount; }
        const subtotal = lines.reduce((sum,line) => sum+line.amount,0);
        const discount = lines.reduce((sum,line) => sum+line.discount,0);
        return {main,extras,count,rate,active,subtotal,discount,total:subtotal-discount};
      }
      changed(event) {
        const extra = event.target.closest('[data-wr-extra]');
        if (extra?.dataset.wrForm === this.dataset.wrForm && event.target.matches('[data-wr-extra-variant]')) {
          const option = event.target.selectedOptions[0];
          if (!option) return;
          extra.dataset.wrVariant = option.value;
          extra.dataset.wrPrice = option.dataset.wrPrice;
          extra.querySelector('[data-wr-extra-price]').textContent = option.dataset.wrPriceText;
        }
        this.update();
      }
      extendFormData(data) {
        const mainId = data.get('id');
        if (!mainId || data.has('items[0][id]')) return;
        const selection = this.selection(mainId,data.get('quantity'));
        if (!selection?.extras.length) return;
        const mainFields = [...data.entries()].filter(([name]) => name === 'id' || name === 'quantity' || name === 'selling_plan' || /^properties\[.+\]$/.test(name));
        for (const [name] of mainFields) data.delete(name);
        for (const [name,value] of mainFields) {
          const key = name.startsWith('properties[') ? `items[0][properties]${name.slice(10)}` : `items[0][${name}]`;
          data.append(key,value);
        }
        data.set('items[0][quantity]',String(selection.main.quantity));
        selection.extras.forEach((line,index) => {
          data.set(`items[${index+1}][id]`,line.id);
          data.set(`items[${index+1}][quantity]`,String(line.quantity));
        });
      }
      amountElement(target,line) {
        const fragment = document.createDocumentFragment();
        target.classList.add('wr-native-summary__amounts');
        if (line.discount) { const old = document.createElement('s'); old.textContent=this.money(line.amount); fragment.append(old); }
        const current = document.createElement('span'); current.textContent=this.money(line.final); fragment.append(current);
        target.replaceChildren(fragment);
      }
      update() {
        const selection = this.selection();
        if (!selection) return;
        const {main,extras} = selection;
        for (const extra of this.extras()) {
          extra.toggleAttribute('data-wr-selected',this.selected(extra));
          const note = extra.querySelector('[data-wr-care-quantity]');
          if (note) note.textContent=this.copy.care_quantity.replace('__QUANTITY__',this.extraQuantity(extra,main.quantity)).replace('__PRICE__',this.money(extra.dataset.wrPrice));
        }
        for (const payment of this.scope.querySelectorAll('.shopify-payment-button')) payment.hidden=extras.length>0;
        for (const summary of this.summaries()) {
          summary.querySelector('[data-wr-main-meta]').textContent=`${main.variant.title === 'Default Title' ? '' : `${main.variant.title} · `}${summary.dataset.wrQuantityLabel} ${main.quantity}`;
          this.amountElement(summary.querySelector('[data-wr-main-price]'),main);
          summary.querySelector('[data-wr-summary-empty]').hidden=extras.length>0;
          const fragment = document.createDocumentFragment();
          for (const selected of extras) {
            const line = document.createElement('div'); line.className='wr-native-summary__line';
            const title = document.createElement('span'); title.textContent=selected.extra.dataset.wrTitle;
            const quantity = document.createElement('small'); quantity.className='wr-native-summary__meta'; quantity.textContent=`${summary.dataset.wrQuantityLabel} ${selected.quantity}`; title.append(quantity);
            const price = document.createElement('span'); this.amountElement(price,selected);
            line.append(title,price); fragment.append(line);
          }
          summary.querySelector('[data-wr-summary-lines]').replaceChildren(fragment);
          summary.querySelector('[data-wr-summary-promotion]').hidden=!selection.active || !selection.count;
          summary.querySelector('[data-wr-offer-heading]').textContent=this.copy.offer;
          summary.querySelector('[data-wr-offer-tier]').textContent=this.copy.tier.replace('__COUNT__',selection.count).replace('__RATE__',selection.rate);
          summary.querySelector('[data-wr-offer-tier]').hidden=!selection.rate;
          summary.querySelector('[data-wr-subtotal-row]').hidden=!selection.discount;
          summary.querySelector('[data-wr-discount-row]').hidden=!selection.discount;
          summary.querySelector('[data-wr-summary-subtotal]').textContent=this.money(selection.subtotal);
          summary.querySelector('[data-wr-summary-discount]').textContent=`−${this.money(selection.discount)}`;
          summary.querySelector('[data-wr-summary-total]').textContent=this.money(selection.total);
        }
      }
    }
    customElements.define('wr-native-purchase-coordinator',WrNativePurchaseCoordinator);
  }
  } catch(e) { console.error(e); }
})();

})();
